<template>
	<div>
		<div class="modal z-100">
			<div class="row">
				<div class="col-md-12 end-sm end-md end-lg">
					<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
				</div>
			</div>
			<div class="row margin-b40">
				<div class="col-md-12 w-full">
					<p class="textGrey textLg textCenter">
						{{ editItem ? `Editing CLI ${item.number}` : 'Creating new CLI block rule' }}
					</p>
				</div>
			</div>
			<div class="row margin-b50">
				<div class="col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 w-full">
					<div class="card formPanel">
						<div class="content">
							<div class="row margin-b20">
								<div class="col-xs-12">
									<div class="formGroup">
										<label class="textGrey">CLI to block </label>
										<input v-model="item.number" type="text" />
									</div>
									<div class="formGroup mt-4">
										<label class="textGrey">Description:</label>
										<div class="formGroup withIcon">
											<textarea
												v-model="item.description"
												class="w-full rounded-sm px-2.5 py-2 text-[14px] transition"
												rows="4"
											></textarea>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row margin-b20">
				<div class="col-md-12 mx-auto">
					<ul class="stepBtns">
						<li><a class="jmiBtn btnLg green" @click="editItem ? update() : save()">Save</a></li>
						<li><a class="jmiBtn btnLg red" @click="close()">Cancel</a></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['user'],
	props: ['editItem'],

	data() {
		return {
			item: {
				number: '',
				description: '',
				user: '',
				createdAt: ''
			}
		}
	},

	created() {
		if (this.editItem) {
			this.item = this.editItem
		}
	},

	methods: {
		close() {
			this.$emit('close')
		},
		save() {
			this.item.user = this.user
			this.item.createdAt = new Date().toISOString()
			this.item.updatedAt = new Date().toISOString()
			this.$emit('save', this.item)
		},
		update() {
			this.item.user = this.user
			this.item.updatedAt = new Date().toISOString()
			this.$emit('update', this.item)
		}
	}
}
</script>
